import { useTranslation } from 'react-i18next';
import { useReduxSrAlert } from '../sr-alerts.hooks';
import { selectAddedItem } from 'redux/cart/cart.selectors';
import { setAddedItem } from 'redux/cart/cart.actions';
import HiddenTypography from 'components/hidden-typography/hidden-typography.component';

const SrItemAddedAlert = () => {
  const { t } = useTranslation();
  const alertMessage = useReduxSrAlert(
    selectAddedItem,
    addedItem => t('itemAdditionSrAlert', { itemName: addedItem }),
    () => setAddedItem(null),
  );

  return <HiddenTypography role="alert">{alertMessage}</HiddenTypography>;
};
export default SrItemAddedAlert;
